module.exports = __webpack_public_path__ + "images/8d18ca6310d7bf13688744fcb757d0f9.png";